// removed by extract-text-webpack-plugin
module.exports = {"footer":"src-components-Footer-__Footer-module___footer","social":"src-components-Footer-__Footer-module___social","lng":"src-components-Footer-__Footer-module___lng","lngName":"src-components-Footer-__Footer-module___lngName","lngWrapper":"src-components-Footer-__Footer-module___lngWrapper","lngContainer":"src-components-Footer-__Footer-module___lngContainer"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.module.css
// module id = 169
// module chunks = 0